<div appFilterColumnsAutoFocus class="flex-column justify-content-center p-5">
    <app-drivers-table></app-drivers-table>
</div>